<script>
import {ref, onMounted, onBeforeUnmount} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";


export default {
  name: 'MyOrders',
  components: {BottomNavigation, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let loading = ref(false)

    let page_select = ref('active')


    let active_orders = ref([])
    let send_orders = ref([])
    let completed_orders = ref([])


    function my_orders() {

      loading.value = true

      FreeWorld.Heisenberg({}, 'orders', true).then((res) => {

        loading.value = false
        chang_orders(res.data)


      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, my_orders)
      })

    }

    my_orders()

    function chang_orders(res) {

      active_orders.value = []
      send_orders.value = []
      completed_orders.value = []

      res.forEach((item) => {

        if (item.status === 1 || item.status === 2 || item.status === 3 || item.status === 4) {
          active_orders.value.push(item)
        } else if (item.status === 5) {
          send_orders.value.push(item)
        } else if (item.status === 6 || item.status === 7 || item.status === 8) {
          completed_orders.value.push(item)
        }

      })

    }

    function cancel_orders(item) {

      Swals.Question('آیا از لغو سفارش اطمینان دارید؟', 'لغو سفارش').then((res) => {
        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({action: 'cancel', oid: item.id}, 'orders_act', true).then((res) => {

            loading.value = false
            if (res.data.status === 'ok') {
              Swals.Done('سفارش شما با موفقیت لغو شد')
              my_orders()
            } else {
              Swals.Fault('متاسفانه سفارش شما لغو نشد!')
            }

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              cancel_orders(item)
            })
          })

        }
      })

    }


    const update_orders = ref(null)

    onMounted(() => {
      update_orders.value = setInterval(() => {

        FreeWorld.Heisenberg({}, 'orders', true).then((res) => {
          chang_orders(res.data)
        }).catch((res) => {
          Swals.Catch(res, my_orders)
        })

      }, 30000)
    })

    onBeforeUnmount(() => {
      clearInterval(update_orders.value)
    })


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });


    return {

      active_orders,
      send_orders,
      completed_orders,
      loading,
      page_select,
      cancel_orders,

    }
  }
}
</script>


<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass' : '' " class="bg-main">

    <div class="div-top-arrow shadow-custom bg-white">
      <div class="d-flex justify-content-between align-items-center">
        <p class="font-color font-4 font-bold">مدیریت سفارشات</p>
        <router-link :to="{name:'HomePage'}">
          <img class="svg-arrow" src="../assets/img/arrow.svg" alt="">
        </router-link>
      </div>
    </div>
    <br>
    <br>
    <br>

    <div class="list_saver d-flex bg-main justify-content-between align-items-center p-body max_width py-3">
      <v-btn @click="page_select = 'active'" :class="page_select === 'active' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 font-6 h-100 rounded-3 border-costom text-white w-30">
        سفارشات فعال
      </v-btn>

      <v-btn @click="page_select = 'send'" :class="page_select === 'send' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-6 rounded-3 border-costom text-white w-30">
        سفارشات در حال ارسال
      </v-btn>

      <v-btn @click="page_select = 'complated'" :class="page_select === 'complated' ? 'bg-color' : 'bg-unavailable' "
             class="title_saver p-2 h-100 font-6 rounded-3 border-costom text-white w-30">
        سفارشات تکمیل شده
      </v-btn>
    </div>

    <br>
    <br>
    <br>
    <br>

    <div v-if="page_select === 'active' ">

      <div v-if="active_orders.length === 0 && !loading"
           class="p-body w-100 d-flex flex-column justify-content-end align-items-center" style="height: 50vh">
        <div class="d-flex flex-column align-items-center">
          <img src="../assets/img/not_orders.png" class="w-60" alt="">
          <br>
          <p class="font-4 ">
            درحال حاضر سفارش فعالی ندارید...
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body animate__animated animate__fadeInRight">
        <!-- == -->
        <div v-for="item in active_orders" :key="item.id"
             class="holder-element-order shadow-custom my-4 position-relative">

          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <div class="d-flex align-items-center">
              <img v-if="item.offer_id !== null" style="width: 35px" class="ml-2" src="../assets/img/shopping-list.svg"
                   alt="">
              <p class="text-white text-center rounded-3 p-2 font-5 font-bold"
                 :style="{backgroundColor: item.status_bg , color:item.status_color}">{{
                  item.status_order
                }}</p>
            </div>

            <div class=" overflow-hidden">
              <p class="font-4 font-bold" :class="{'txtoverflow':item.shopname.length > 23}">{{ item.shopname }}</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">تاریخ سفارش</p>

            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.day }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.time }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between">
            <p class="font-5 m-0">کد رهگیری</p>
            <p class="font-5 m-0 tracking-Code">{{ item.code }}</p>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">مبلغ کل سفارش</p>

            <div class="d-flex">
              <p class="font-5 m-0">{{ item.price.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">مبلغ تخفیف</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.price_off.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">وضعیت پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_status }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">طریقه پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_type }}</p>
            </div>
          </div>

          <div v-if="item.info !== null" class="">
            <hr class="hr-order bg-color">

            <div class="d-flex justify-content-between align-items-center">
              <p class="font-5 m-0">توضیحات سفارش</p>

              <div dir="rtl" class="d-flex w-65 justify-end">
                <p class="font-5 m-0">{{ item.info }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <p class="font-4 mb-2">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 15rem;min-width: 15rem"
                 class="d-flex justify-content-between mx-1 animate__animated animate__fadeInRight">
              <div class="img-food-order animated-background rounded-3">
                <img class="img-food-order w-100 rounded-3" :src="prod.pic" alt="">
              </div>

              <div class="mx-1 w-50 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 9}" class="font-6 mb-2 text-end font-bold">{{
                      prod.name
                    }}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                <span>
                {{ prod.number }}
              </span>
                  &nbsp;
                  <span>
                 عدد
                </span>
                </p>
              </div>
            </div>

          </div>

          <hr v-if="item.status === 1 || item.status === 2" class="hr-order  bg-color">

          <div class="animate__animated animate__fadeInDown">

            <div v-if="item.status === 1" class="d-flex justify-center">
              <v-btn @click="cancel_orders(item)"
                     class="font-5 rounded-3 border-0 p-2 bg-danger w-60 text-white h-100 shadow-custom">لغو سفارش
              </v-btn>
            </div>


            <div v-if="item.status === 2" class="w-100 d-flex justify-space-between align-items-center mt-3">
              <router-link :to="{name:'FinalPayment',params:{oid:item.id,sid:item.sid}}" class="w-45 mx-2">
                <v-btn class="font-5 rounded-3 border-0 p-2 bg-color w-100 text-white h-100 shadow">پرداخت نهایی سفارش
                </v-btn>
              </router-link>
              <v-btn @click="cancel_orders(item)"
                     class="font-5 rounded-3 border-0 p-2 bg-danger w-45 text-white h-100 shadow-custom">لغو سفارش
              </v-btn>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div v-if="page_select === 'send' ">

      <div v-if="send_orders.length === 0 && !loading"
           class="p-body w-100 d-flex flex-column justify-content-end align-items-center" style="height: 50vh">
        <div class="d-flex flex-column align-items-center">
          <img src="../assets/img/not_orders.png" class="w-60" alt="">
          <br>
          <p class="font-4 ">
            درحال حاضر سفارش درحال ارسال ندارید...
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body animate__animated animate__fadeInRight">
        <!-- == -->
        <div v-for="item in send_orders" :key="item.id"
             class="holder-element-order shadow-custom my-4 position-relative">

          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <div class="d-flex align-items-center">
              <img v-if="item.offer_id !== null" style="width: 35px" class="ml-2" src="../assets/img/shopping-list.svg"
                   alt="">
              <p class="text-white text-center rounded-3 p-2 font-5 font-bold"
                 :style="{backgroundColor: item.status_bg , color:item.status_color}">{{
                  item.status_order
                }}</p>
            </div>

            <div class=" overflow-hidden">
              <p class="font-4 font-bold" :class="{'txtoverflow':item.shopname.length > 23}">{{ item.shopname }}</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">تاریخ سفارش</p>

            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.day }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.time }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between">
            <p class="font-5 m-0">کد رهگیری</p>
            <p class="font-5 m-0 tracking-Code">{{ item.code }}</p>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">مبلغ کل سفارش</p>

            <div class="d-flex">
              <p class="font-5 m-0">{{ item.price.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">مبلغ تخفیف</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.price_off.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">وضعیت پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_status }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">طریقه پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_type }}</p>
            </div>
          </div>

          <div v-if="item.info !== null" class="">
            <hr class="hr-order bg-color">

            <div class="d-flex justify-content-between align-items-center">
              <p class="font-5 m-0">توضیحات سفارش</p>

              <div dir="rtl" class="d-flex w-65 justify-end">
                <p class="font-5 m-0">{{ item.info }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <p class="font-4 mb-2">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 15rem;min-width: 15rem"
                 class="d-flex justify-content-between mx-1 animate__animated animate__fadeInRight">
              <div class="img-food-order animated-background rounded-3">
                <img class="img-food-order w-100 rounded-3" :src="prod.pic" alt="">
              </div>

              <div class="mx-1 w-50 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 9}" class="font-6 mb-2 text-end font-bold">{{
                      prod.name
                    }}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                <span>
                {{ prod.number }}
              </span>
                  &nbsp;
                  <span>
                 عدد
                </span>
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <div v-if="page_select === 'complated'">

      <div v-if="completed_orders.length === 0 && !loading"
           class="p-body w-100 d-flex flex-column justify-content-end align-items-center" style="height: 50vh">
        <div class="d-flex flex-column align-items-center">
          <img src="../assets/img/not_orders.png" class="w-60" alt="">
          <br>
          <p class="font-4 ">
            درحال حاضر سفارش تکمیل شده ندارید...
          </p>
        </div>
      </div>

      <div v-else class="mt-2 p-body animate__animated animate__fadeInRight">
        <!-- == -->
        <div v-for="item in completed_orders" :key="item.id"
             class="holder-element-order shadow-custom my-4 position-relative">

          <div class="d-flex align-items-center justify-content-between flex-row-reverse">
            <div class="d-flex align-items-center">
              <img v-if="item.offer_id !== null" style="width: 35px" class="ml-2" src="../assets/img/shopping-list.svg"
                   alt="">
              <p class="text-white text-center rounded-3 p-2 font-5 font-bold"
                 :style="{backgroundColor: item.status_bg , color:item.status_color}">{{
                  item.status_order
                }}</p>
            </div>

            <div class=" overflow-hidden">
              <p class="font-4 font-bold" :class="{'txtoverflow':item.shopname.length > 23}">{{ item.shopname }}</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">تاریخ سفارش</p>

            <div class="data-left d-flex justify-content-center">
              <p class="font-5 m-0">{{ item.day }}</p>
              <p class="font-5 m-0 mx-3">{{ item.date }}</p>
              <p class="font-5 m-0">{{ item.time }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between">
            <p class="font-5 m-0">کد رهگیری</p>
            <p class="font-5 m-0 tracking-Code">{{ item.code }}</p>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex align-items-center justify-content-between">
            <p class="font-5 m-0">مبلغ کل سفارش</p>

            <div class="d-flex">
              <p class="font-5 m-0">{{ item.price.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">مبلغ تخفیف</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.price_off.toLocaleString() }}</p>
              &nbsp;
              <p class="font-5 m-0">تومان</p>
            </div>
          </div>

          <hr class="hr-order  bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">وضعیت پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_status }}</p>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <div class="d-flex justify-content-between align-items-center">
            <p class="font-5 m-0">طریقه پرداخت</p>

            <div class="d-flex ">
              <p class="font-5 m-0">{{ item.pay_type }}</p>
            </div>
          </div>

          <div v-if="item.info !== null" class="">
            <hr class="hr-order bg-color">

            <div class="d-flex justify-content-between align-items-center">
              <p class="font-5 m-0">توضیحات سفارش</p>

              <div dir="rtl" class="d-flex w-65 justify-end">
                <p class="font-5 m-0">{{ item.info }}</p>
              </div>
            </div>
          </div>

          <hr class="hr-order bg-color">

          <p class="font-4 mb-2">
            اقلام سفارش
          </p>

          <div id="list_orders" class="holder-img-food">

            <div v-for="prod in item.products" :key="prod.id" style="width: 15rem;min-width: 15rem"
                 class="d-flex justify-content-between mx-1 animate__animated animate__fadeInRight">
              <div class="img-food-order animated-background rounded-3">
                <img class="img-food-order w-100 rounded-3" :src="prod.pic" alt="">
              </div>

              <div class="mx-1 w-50 py-2 d-flex flex-column justify-content-between">
                <div class="overflow-hidden">
                  <p :class="{'txtoverflow':prod.name.length >= 9}" class="font-6 mb-2 text-end font-bold">{{
                      prod.name
                    }}</p>
                </div>

                <p class="d-flex m-0 p-1 font-5 justify-content-center w-100  bg-dark-subtle rounded-pill font-color ">
                <span>
                {{ prod.number }}
              </span>
                  &nbsp;
                  <span>
                 عدد
                </span>
                </p>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>

    <BottomNavigation></BottomNavigation>

  </div>
</template>


<style scoped>

.list_saver {
  width: 100%;
  height: 5rem;
  direction: rtl;
  position: fixed;
  top: 4.8rem;
  z-index: 1;
}

.title_saver {
  min-height: 50px;
}


.swall {
  width: 95%;
  direction: ltr;
}

/* === */

.holder-element-order {
  width: 100%;
  border-radius: 10px;
  padding: 20px 25px;
}


.text-condition-cancellation {
  background-color: #b6b6b6;
  padding: 5px 15px;
}

.hr-order {
  width: 100%;
  /* margin: 10px 0 !important; */
}


.holder-img-food {
  padding: 5px 0;
  overflow-x: scroll;
  display: flex;
}

.holder-img-food::-webkit-scrollbar {
  display: none;
}

.img-food-order {
  height: 8rem;
}


</style>